import { render, staticRenderFns } from "./ModelEditArchive.vue?vue&type=template&id=775d158e"
import script from "./ModelEditArchive.vue?vue&type=script&lang=js"
export * from "./ModelEditArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports